import Calendar from '@fullcalendar/react'
import { ComponentProps, RefObject } from 'react'
import { VIEW_TYPE } from './calendar.constants'

// import type { EventContentArg, EventSourceInput } from "@fullcalendar/core";
// import type { DateClickArg } from "@fullcalendar/interaction";

export const NAVIGATE_TYPE = {
  NEXT: 'next',
  PREV: 'prev',
} as const

export type NavigateType = (typeof NAVIGATE_TYPE)[keyof typeof NAVIGATE_TYPE]

export type ViewType = (typeof VIEW_TYPE)[keyof typeof VIEW_TYPE]

export interface CalendarEventInfo {}

export interface CalendarProps extends ComponentProps<typeof Calendar> {
  className?: string
  ref: RefObject<any>
  calendarEvents: unknown
  hourDisplay?: number
  currentView: ViewType
  fullCalendarView: string
  resources: any[]
  // getEventAppearance: (event: any) => "";
  onDateClick?: (info: unknown) => void
  onEventResize?: (info: unknown) => void
  onClickEvent?: (eventInfo: unknown) => void
  onDropEvent?: (info: unknown) => void
  calendarLoading?: (loading: boolean) => void
  scrollTime?: string
}
